import { StateCreator } from 'zustand'
import { ShoppingListItem } from '../types'

export interface ShoppingSlice {
  shoppingList: ShoppingListItem[]
  addShoppingListItem: (item: ShoppingListItem) => void
  updateShoppingListItem: (
    id: string,
    updatedItem: Partial<ShoppingListItem>,
  ) => void
  removeShoppingListItem: (id: string) => void
  toggleShoppingListItem: (id: string) => void
  clearCompletedShoppingListItems: () => void
  setShoppingList: (items: ShoppingListItem[]) => void
}

export const createShoppingSlice: StateCreator<ShoppingSlice> = (set) => ({
  shoppingList: [],
  addShoppingListItem: (item) =>
    set((state) => ({ shoppingList: [...state.shoppingList, item] })),
  updateShoppingListItem: (id, updatedItem) =>
    set((state) => ({
      shoppingList: state.shoppingList.map((item) =>
        item.id === id ? { ...item, ...updatedItem } : item,
      ),
    })),
  removeShoppingListItem: (id) =>
    set((state) => ({
      shoppingList: state.shoppingList.filter((item) => item.id !== id),
    })),
  toggleShoppingListItem: (id) =>
    set((state) => ({
      shoppingList: state.shoppingList.map((item) =>
        item.id === id ? { ...item, isCompleted: !item.isCompleted } : item,
      ),
    })),
  clearCompletedShoppingListItems: () =>
    set((state) => ({
      shoppingList: state.shoppingList.filter((item) => !item.isCompleted),
    })),
  setShoppingList: (items) => set({ shoppingList: items }),
})
